import { TurnkeySolanaWalletConnectors } from '@dynamic-labs/turnkey';
import { Phantom } from './Phantom.js';
import { injectedWalletOverrides, fetchInjectedWalletConnectors } from './injected/fetchInjectedWalletConnectors.js';
export { isSignedMessage } from './utils/isSignedMessage.js';
export { isBackpackSolanaSigner } from './utils/isBackpackSolanaSigner.js';

/* eslint-disable @typescript-eslint/no-unused-vars */
const SolanaWalletConnectors = (props) => [
    ...injectedWalletOverrides,
    ...fetchInjectedWalletConnectors(props),
    ...TurnkeySolanaWalletConnectors(props),
    Phantom,
];

export { SolanaWalletConnectors };
